module.exports = __webpack_public_path__ + "21e120cf8286cd433ac391ee087a5350.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/foldermanager_header_desc_2x.png
// module id = 132
// module chunks = 0 1 2 3 4